/* istanbul ignore next */
const ACTIONS = {
    SET_COMPANY_LOCATION: 'SET_COMPANY_LOCATION',
    GET_LOCATION_METADATA: 'GET_LOCATION_METADATA',
    GET_LOCATION_METADATA_SUCCESS: 'GET_LOCATION_METADATA_SUCCESS',
    COMPANY_LOCATION_ERROR: 'COMPANY_LOCATION_ERROR',
    COMPANY_LOCATION_FIELD_ERROR: 'COMPANY_LOCATION_FIELD_ERROR',
    TOGGLE_COMPANY_LOC_CONTINUE_BUTTON: 'TOGGLE_COMPANY_LOC_CONTINUE_BUTTON',
    SUBMIT_COMPANY_LOCATION: 'SUBMIT_COMPANY_LOCATION',
    DISMISS_ALERT_BOX: 'DISMISS_ALERT_BOX',
    UPDATE_VAT_DETAILS: 'UPDATE_VAT_DETAILS',
    PRE_POPULATE_LOCAL_STATE_COMP_LOC: 'PRE_POPULATE_LOCAL_STATE_COMP_LOC',
    SET_COMPANY_LOCATION_FIELD_ERROR: 'SET_COMPANY_LOCATION_FIELD_ERROR',
    HANDLE_COMP_LOC_FIELD_VALUE_CHANGE: 'HANDLE_COMP_LOC_FIELD_VALUE_CHANGE',
    VERIFY_SITE: 'VERIFY_SITE',
    TOGGLE_COMP_LOC_CONTINUE_BUTTON: 'TOGGLE_COMP_LOC_CONTINUE_BUTTON',
    TOGGLE_REGISTRATION_NUMBER_FIELD: 'TOGGLE_REGISTRATION_NUMBER_FIELD',
    SET_REGISTRATION_NUMBER_FIELD: 'SET_REGISTRATION_NUMBER_FIELD',
    PRE_POPULATE_COMPANY_LOC_FROM_BILLING_SETUP_META: 'PRE_POPULATE_COMPANY_LOC_FROM_BILLING_SETUP_META'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    setCompanyLocation(fieldVal) {
        return {
            type: ACTIONS.SET_COMPANY_LOCATION,
            payload: {
                fieldVal
            }
        };
    },

    toggleContinueButtonView() {
        return {
            type: ACTIONS.TOGGLE_COMPANY_LOC_CONTINUE_BUTTON
        };
    },

    getLocationMetadata() {
        return {
            type: ACTIONS.GET_LOCATION_METADATA
        };
    },

    getLocationMetadataSuccess(locationMetadata) {
        return {
            type: ACTIONS.GET_LOCATION_METADATA_SUCCESS,
            payload: {
                locationMetadata
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.COMPANY_LOCATION_ERROR,
            payload: {
                errorKey
            }
        };
    },

    submitCompanyLocation(companyLocation) {
        return {
            type: ACTIONS.SUBMIT_COMPANY_LOCATION,
            payload: {
                companyLocation
            }
        };
    },

    updateVatDetails(vatDetails, isBillingSetupFlow = false) {
        return {
            type: ACTIONS.UPDATE_VAT_DETAILS,
            payload: {
                vatDetails,
                isBillingSetupFlow,
                isFromCompanyLocation: true
            }
        };
    },


    setCompanyLocationError(errorKey) {
        return {
            type: ACTIONS.COMPANY_LOCATION_FIELD_ERROR,
            payload: {
                errorKey
            }
        };
    },

    dismissAlertBox() {
        return {
            type: ACTIONS.DISMISS_ALERT_BOX
        };
    },

    prePopulateLocalState(publicUuid) {
        return {
            type: ACTIONS.PRE_POPULATE_LOCAL_STATE_COMP_LOC,
            payload: {
                publicUuid
            }
        };
    },

    setFieldError(fieldName, msg) {
        return {
            type: ACTIONS.SET_COMPANY_LOCATION_FIELD_ERROR,
            payload: {
                fieldName,
                msg
            }
        };
    },

    handleFieldValueChange(fieldName, fieldValue) {
        return {
            type: ACTIONS.HANDLE_COMP_LOC_FIELD_VALUE_CHANGE,
            payload: {
                fieldName,
                fieldValue
            }
        };
    },

    toggleRegistrationNumberField(fieldValue, siteName) {
        return {
            type: ACTIONS.TOGGLE_REGISTRATION_NUMBER_FIELD,
            payload: {
                fieldValue,
                siteName
            }
        };
    },

    setRegistrationNumberField(fieldValue, siteName) {
        return {
            type: ACTIONS.SET_REGISTRATION_NUMBER_FIELD,
            payload: {
                fieldValue,
                siteName
            }
        };
    },

    verifySite(siteName, isBillingSetupFlow = false) {
        return {
            type: ACTIONS.VERIFY_SITE,
            payload: {
                siteName,
                isBillingSetupFlow,
            }
        };
    },

    toggleContinueButton() {
        return {
            type: ACTIONS.TOGGLE_COMP_LOC_CONTINUE_BUTTON
        };
    },

    prePopulateFromBillingSetupMetadata(userMeta, vatMeta) {
        return {
            type: ACTIONS.PRE_POPULATE_COMPANY_LOC_FROM_BILLING_SETUP_META,
            payload: {
                userMeta,
                vatMeta
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
